const PRIVATE_KEY_BLOCK_PATTERN = /-----BEGIN [^-]*PRIVATE KEY-----[\s\S]*?-----END [^-]*PRIVATE KEY-----/gi;

// SECRET also matches as a mid-key stem (rotation siblings like *_SECRET_PREVIOUS) or a leading segment (SECRET_STORE); never a substring (SECRETARY).
const SECRET_ASSIGNMENT_PATTERN =
  /([A-Za-z_][A-Za-z0-9_]*(?:_KEY|_TOKEN|_PASSWORD|_PASSWD)|SECRET_[A-Za-z0-9_]*|[A-Za-z_][A-Za-z0-9_]*_SECRET(?:_[A-Za-z0-9_]+)?)(\s*=\s*|\s*:\s*)("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|-----BEGIN [^-]*PRIVATE KEY-----[\s\S]*?-----END [^-]*PRIVATE KEY-----|[^\s"',;,)]+)/gi;

const URL_PASSWORD_PATTERN = /([a-zA-Z][a-zA-Z0-9+.-]*:\/\/[^/\s:@]*:)([^/\s@]+)(@)/g;

const BEARER_TOKEN_PATTERN = /(Authorization\s*:\s*Bearer\s+)([^\s"',;,)]+)/gi;

// Secret-ish param names only, each either standalone or trailing a separator so `monkey` / `token_type` never match.
const SECRET_QUERY_PARAM_PATTERN =
  /([?&#](?:[A-Za-z0-9_.-]*[_.-])?(?:apikey|token|key|secret|password|passwd|pwd|signature|sig|auth(?:orization)?)=)([^&#\s"',;,)]+)/gi;

export const SCRUBBED_PRIVATE_KEY = '[REDACTED PRIVATE KEY]';

export const STDERR_TAIL_MARKER = '\n--- stderr (tail) ---\n';

export const STDERR_TAIL_MAX_CHARS = 2000;

function replaceSecretAssignment(match: string, key: string, separator: string, value: string): string {
  // Already-scrubbed values pass through untouched so scrubbing stays idempotent.
  if (value.startsWith('***') || value.startsWith('[REDACTED')) return match;
  if (/PRIVATE KEY-----/i.test(value)) return `${key}${separator}${SCRUBBED_PRIVATE_KEY}`;
  return `${key}${separator}***`;
}

export function scrubSecretsForDisplay(input: string): string {
  return input
    .replace(SECRET_QUERY_PARAM_PATTERN, '$1***')
    .replace(SECRET_ASSIGNMENT_PATTERN, replaceSecretAssignment)
    .replace(PRIVATE_KEY_BLOCK_PATTERN, SCRUBBED_PRIVATE_KEY)
    .replace(URL_PASSWORD_PATTERN, '$1***$3')
    .replace(BEARER_TOKEN_PATTERN, '$1***');
}

export function appendScrubbedStderrTail(message: string, stderr: unknown): string {
  const safeMessage = scrubSecretsForDisplay(message);
  // /\S/ detects blank strings without copying huge stderr the way trim() would.
  if (typeof stderr !== 'string' || !/\S/.test(stderr)) return safeMessage;
  // Scrub before slicing so a cut mid-token cannot sever the key name and leak a partial secret.
  return `${safeMessage}${STDERR_TAIL_MARKER}${scrubSecretsForDisplay(stderr).slice(-STDERR_TAIL_MAX_CHARS)}`;
}

export function extractStderrText(err: unknown): string | null {
  if (typeof err !== 'object' || err === null) return null;
  const stderr: unknown = (err as { stderr?: unknown }).stderr;
  return typeof stderr === 'string' && stderr.length > 0 ? stderr : null;
}
